module.exports = __webpack_public_path__ + "static/team_6-4833100c933f4abb676934e31b4d2e6c.jpg";